import windowHelper from "@dpa-connect/dpa-id-user/store/utils/window";

export default windowHelper;
